import PageHeader from "@/components/PageHeader";
import Reveal from "@/components/Reveal";
import CTAButton from "@/components/CTAButton";
import { useContent } from "@/context/ContentContext";
import { RESUME_URL, EMAIL } from "@/data/content";

const FACTS = [
    ["AGE", "22"],
    ["FROM", "Kaimganj (Farrukhabad)"],
    ["BASED IN", "Delhi NCR"],
    ["EDUCATION", "BBA — GGSIPU, Class of 2026"],
];

export default function About() {
    const content = useContent();
    return (
        <>
            <PageHeader
                crumb="HOME / ABOUT"
                eyebrow="01 — WHO I AM"
                lines={["ABOUT ME"]}
                sub="Marketing mind. Builder's hands."
            />

            <section className="px-5 lg:px-12 xl:px-16 py-16 lg:py-24 grid gap-12 lg:grid-cols-[1.2fr_0.8fr]">
                <Reveal>
                    <p className="text-lg md:text-xl leading-relaxed">
                        {content.about_p1}
                    </p>
                    <p className="mt-6 text-lg md:text-xl leading-relaxed text-muted2">
                        {content.about_p2}
                    </p>
                    <dl className="mt-12 border-t border-line">
                        {FACTS.map(([k, v]) => (
                            <div
                                key={k}
                                className="flex items-center justify-between gap-6 border-b border-line py-4"
                                data-testid={`about-fact-${k
                                    .toLowerCase()
                                    .replace(/\s+/g, "-")}`}
                            >
                                <dt className="mono text-[11px] tracking-[0.25em] text-muted2">
                                    {k}
                                </dt>
                                <dd className="mono text-sm text-right">
                                    {v}
                                </dd>
                            </div>
                        ))}
                    </dl>
                    <div className="mt-10 flex flex-wrap gap-4">
                        <CTAButton
                            href={RESUME_URL}
                            testid="about-download-resume"
                        >
                            DOWNLOAD RESUME
                        </CTAButton>
                        <CTAButton
                            href={`mailto:${EMAIL}`}
                            testid="about-email-cta"
                        >
                            SAY HELLO
                        </CTAButton>
                    </div>
                </Reveal>
                <Reveal delay={0.12}>
                    <div className="overflow-hidden border border-line">
                        <img
                            src="https://images.unsplash.com/photo-1668630491137-6f39aec7ea33?auto=format&fit=crop&w=1200&q=80"
                            alt="Devang's desk — coffee and notebook"
                            className="aspect-[4/5] w-full object-cover transition-transform duration-700 hover:scale-105"
                            data-testid="about-page-image"
                        />
                    </div>
                    <p className="mono text-[10px] tracking-[0.25em] text-muted2 mt-3">
                        FIG. 01 — WHERE THE WORK HAPPENS
                    </p>
                </Reveal>
            </section>

            <section className="px-5 lg:px-12 xl:px-16 pb-20 lg:pb-28">
                <Reveal>
                    <div
                        className="bg-sagepanel border border-line p-8 lg:p-12"
                        data-testid="about-goals-panel"
                    >
                        <p className="mono text-xs tracking-[0.3em]">
                            MY GOALS ————
                        </p>
                        <div className="mt-8 grid gap-6 md:grid-cols-2">
                            {content.goals.map((g, i) => (
                                <div
                                    key={i}
                                    className="flex gap-5 border-t border-ink/15 pt-5"
                                >
                                    <span className="mono text-sm pt-0.5">
                                        0{i + 1}
                                    </span>
                                    <p className="text-base md:text-lg leading-snug">
                                        {g}
                                    </p>
                                </div>
                            ))}
                        </div>
                        <p className="serif-it text-xl md:text-2xl mt-10">
                            Big dreams. Practical steps.
                        </p>
                    </div>
                </Reveal>
            </section>
        </>
    );
}
